import { useAuth } from '../../store/auth'

export const useFullySignedIn = () => {
  const claims = useAuth(s => s.claims)

  return !!claims?.firebase?.sign_in_second_factor
}
